import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { DefaultLoadingManager } from 'three';
import create from 'zustand';
var saveLastTotalLoaded = 0;
var useProgress = create(function (set) {
  DefaultLoadingManager.onStart = function (item, loaded, total) {
    set({
      active: true,
      item: item,
      loaded: loaded,
      total: total,
      progress: (loaded - saveLastTotalLoaded) / (total - saveLastTotalLoaded) * 100
    });
  };

  DefaultLoadingManager.onLoad = function () {
    set({
      active: false
    });
  };

  DefaultLoadingManager.onError = function (item) {
    return set(function (state) {
      return {
        errors: [].concat(_toConsumableArray(state.errors), [item])
      };
    });
  };

  DefaultLoadingManager.onProgress = function (item, loaded, total) {
    if (loaded === total) {
      saveLastTotalLoaded = total;
    }

    set({
      active: true,
      item: item,
      loaded: loaded,
      total: total,
      progress: (loaded - saveLastTotalLoaded) / (total - saveLastTotalLoaded) * 100 || 100
    });
  };

  return {
    errors: [],
    active: false,
    progress: 0,
    item: '',
    loaded: 0,
    total: 0
  };
});
export { useProgress };